import request from "@/shared/api/request";

export type ExportTaskStatus = "queued" | "processing" | "succeeded" | "failed" | "cancelled";

export interface ExportTask {
  id: string;
  status: ExportTaskStatus;
  progress_percent: number;
  processed_count: string;
  total_count: string;
  attempt_count: number;
  download_url: string;
  download_expired_in_seconds: string;
  error_code: string;
  error_message: string;
}

export function createExportTask() {
  return request.post<ExportTask>("/api/v1/exports", {});
}

export function getExportTask(id: string) {
  return request.get<ExportTask>(`/api/v1/exports/${id}`, undefined, {
    silent: true,
    skipCancelToken: true,
  });
}

export function cancelExportTask(id: string) {
  return request.post<ExportTask>(`/api/v1/exports/${id}/cancel`, {});
}
